// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"358":"49566502","691":"7c43f639","765":"de605374","970":"df2736e8","991":"d350cf30"}[chunkId] + ".chunk.css";
};